/**
 * 백엔드/SSE 등에서 오는 영문 실행 로그를 UI용 한글과 맞춥니다.
 * (알 수 없는 문자열은 원문 그대로 둡니다.)
 */
const EXACT: Record<string, string> = {
  'Execution was canceled.': '실행이 취소되었습니다.',
  'Execution was canceled': '실행이 취소되었습니다.',
  'Execution canceled.': '실행이 취소되었습니다.',
  'Execution canceled': '실행이 취소되었습니다.',
  'Execution canceled by user.': '사용자에 의해 실행이 취소되었습니다.',
  'Execution canceled by user': '사용자에 의해 실행이 취소되었습니다.',

  'Execution request accepted. Waiting for resources...': '실행 요청이 접수되었습니다. 리소스를 기다리는 중...',
  'Execution started. Loading dataset and training model...':
    '실행을 시작했습니다. 데이터셋, 피처셋 및 파라미터셋을 불러오며 모델을 학습 중입니다...',
  'Execution completed successfully. Metrics and artifacts are available.':
    '실행이 성공적으로 완료되었습니다. 메트릭과 산출물을 확인할 수 있습니다.',

  'Execution failed.': '실행에 실패했습니다.',
  'Execution failed': '실행에 실패했습니다.',

  'Starting experiment.': '실험을 시작합니다.',
  'Starting experiment...': '실험을 시작합니다...',
  'Starting experiment': '실험을 시작합니다',

  'Demo execution failed': '데모 실행이 실패했습니다.',
  'Demo execution failed.': '데모 실행이 실패했습니다.',
};

const normalizeKey = (s: string): string => s.trim().replace(/\s+/g, ' ');

const LOOKUP_LOWER = (() => {
  const m = new Map<string, string>();
  for (const [key, value] of Object.entries(EXACT)) {
    const norm = normalizeKey(key);
    const lowerFull = norm.toLowerCase();
    m.set(lowerFull, value);
    const noDot = lowerFull.replace(/\.$/, '');
    if (noDot !== lowerFull) {
      m.set(noDot, value);
    }
  }
  return m;
})();

export function translateExecutionWorkbenchLogLine(raw: string): string {
  const t = normalizeKey(raw);
  if (!t) return raw;

  if (EXACT[t]) return EXACT[t];
  if (EXACT[raw.trim()]) return EXACT[raw.trim()];

  const lower = t.toLowerCase();
  const withDot = lower.endsWith('.') ? lower : `${lower}.`;
  const noDot = lower.replace(/\.$/, '');

  return LOOKUP_LOWER.get(lower) ?? LOOKUP_LOWER.get(withDot) ?? LOOKUP_LOWER.get(noDot) ?? raw;
}
